import { Spinner } from './styles';

interface IProps {
  width?: string;
  height?: string;
}
export const Loader: React.FC<IProps> = ({ width, height }) => {
  return <Spinner width={width} height={height} />;
};
